import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmericanexpressComponent } from './simple-icons-americanexpress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmericanexpressComponent ],
    exports:      [ SimpleIconsAmericanexpressComponent ],
    bootstrap:    []
})
export class SimpleIconsAmericanexpressModule {}
